import axios from "axios";
import qs from "qs";
import { JTS_API_BASE_URL } from "../../../constants/Constants";

const MANAGE_USERS_QUERY_TYPE = 99999;
const MANAGE_USERS_QUERY_PARAM = "manageUsers";

const normalizeAdmin = (admin) => {
  if (admin == null) return undefined;
  const v = String(admin).trim();
  if (!v) return undefined;
  if (/^s$/i.test(v) || /^si$/i.test(v)) return "S";
  if (/^n$/i.test(v) || /^no$/i.test(v)) return "N";
  return v;
};

const normalizeGenero = (genero) => {
  if (genero == null) return undefined;
  const v = String(genero).trim();
  if (!v) return undefined;
  return v;
};

const getRequestUrl = () => `${JTS_API_BASE_URL}/index.php`;

/**
 * Admin/users management via new jts-api endpoint.
 * - create/update/delete/restore
 * - soft-delete for delete, restore for restore
 */
export const manageUsers = async ({
  action,
  usuario,
  usuario_old,
  name,
  password,
  lang,
  admin,
  genero,
  cod_team,
  minutos,
  minutosefectivosdia,
  permisos,
}) => {
  const url = getRequestUrl();

  const queryData = {
    query_type: MANAGE_USERS_QUERY_TYPE,
    query_param: MANAGE_USERS_QUERY_PARAM,
    action,
  };

  // Required/optional fields depending on action:
  // create: usuario, name, password, lang, admin, genero?, cod_team?, minutos?, minutosefectivosdia?
  // update: usuario (new), usuario_old, name, lang, admin, genero?, cod_team?, minutos?, minutosefectivosdia?, password?
  // delete: usuario
  // restore: usuario
  if (usuario != null) queryData.usuario = usuario;
  if (usuario_old != null) queryData.usuario_old = usuario_old;
  if (name != null) queryData.name = name;
  if (password != null) queryData.password = password;
  if (lang != null) queryData.lang = lang;
  if (admin != null) queryData.admin = normalizeAdmin(admin);
  const g = normalizeGenero(genero);
  if (g != null) queryData.genero = g;
  if (cod_team != null) queryData.cod_team = cod_team;
  if (minutos != null) queryData.minutos = minutos;
  if (minutosefectivosdia != null) queryData.minutosefectivosdia = minutosefectivosdia;
  if (permisos != null && String(permisos).trim() !== "") {
    queryData.permisos = permisos;
  }

  try {
    const response = await axios.post(url, qs.stringify(queryData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    // Contract says: { status: "ok"/"error", data: {...} }
    if (response?.data?.status === "ok") return response.data;
    return response.data;
  } catch (error) {
    console.error("manageUsers: error", error);
    return { status: "error", message: error?.response?.data?.message || error.message || "Error de conexión" };
  }
};

